import IdeationListItem from './IdeationListItem'

const IdeationList = (props) => (
  <table className='ideation-list_table table table-bordered'>
    <thead className='ideation-list__table-header'>
      <tr>
        <th> Status </th>
        <th> Background Color </th>
        <th> Text Color </th>
        <th> Actions </th>
      </tr>
    </thead>
    <tbody>
      {
        props.list.map((item, idx) => <IdeationListItem deleteCallback={props.deleteCallback} openEditIdeationModal={props.openEditIdeationModal} item={item} idx={idx} colors={props.colors} />)
      }
    </tbody>
  </table>
)

export default IdeationList
